import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class VertivalStopsListComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentWidthRatio = component.width / 400.0 * dimentionsRatio;
        const componentHeightRatio = component.height / 1200.0 * dimentionsRatio;

        const textElementPosX = component.drawPositionX + 50 * componentWidthRatio;
        const textElementPosY = component.drawPositionY + 50 * componentHeightRatio;

        const componentSecundaryColor = "#C3E2F0";
        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;

        let fontSize = 35;
        if (6 * fontSize > componentWidth) {
            fontSize = componentWidth / 6.0;
        }
        if(fontSize > componentHeight) {
            fontSize *= componentHeight / fontSize;
        }

        const rectElements = [];
        let nextRectPosY = textElementPosY + fontSize + 10;
        const rectPosX = component.drawPositionX + 50 * componentWidthRatio;
        const rectHeight = 20;
        const rectWidth = 300 * componentWidthRatio;

        const heightLimit = componentHeight + component.drawPositionY - 5;
        while (heightLimit > nextRectPosY + rectHeight) {
            rectElements.push(
                <Group key={nextRectPosY}>
                    <Rect x={rectPosX}
                        y={nextRectPosY}
                        width={rectWidth}
                        height={rectHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>
            );

            nextRectPosY += rectHeight + 10;
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={componentWidth}
                    height={componentHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Text text="Espinha"
                        fontSize={fontSize}
                        x={textElementPosX}
                        y={textElementPosY} />
                </Group>

                {rectElements}
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/VertivalStopsListComponentCanvas.js